/* eslint-disable camelcase */
import { z } from 'zod';
import { WithOrganizationId } from '~/types/common';
import { integrationEmailApi } from '~/utils/api';

export const EmailConfiguration = z.object({
  diagnostic: z.object({
    is_working: z.boolean(),
  }),
  host: z.string().min(1),
  port: z.preprocess((inputValue) => {
    const parsedNumber = Number(inputValue);

    if (Number.isNaN(parsedNumber)) {
      return null;
    }

    return parsedNumber;
  }, z.number().positive()),
  authentication: z.object({
    username: z.string().min(1),
    password: z.string().min(1),
  }),
  from: z.object({
    name: z.string().min(1),
    address: z.string().min(1),
  }),
});

export type EmailConfiguration = z.infer<typeof EmailConfiguration>;

export const getEmailConfiguration = async ({ organizationId }: WithOrganizationId) =>
  integrationEmailApi.get<EmailConfiguration | null>(
    `/organizations/${organizationId}/configuration`,
  );

export const upsertEmailConfiguration = async ({
  organizationId,
  configuration,
}: { configuration: EmailConfiguration } & WithOrganizationId) =>
  integrationEmailApi.put<EmailConfiguration>(
    `/organizations/${organizationId}/configuration`,
    configuration,
  );

export const deleteEmailConfiguration = async ({ organizationId }: WithOrganizationId) =>
  integrationEmailApi.delete<{ configuration: null }>(
    `/organizations/${organizationId}/configuration`,
  );
